import { get, isMockMode, simulateDelay } from "../api";

const removeNone = (roles) => roles.filter((role) => role.roleId !== 0);

export const getOrgRoles = () => {
	if (isMockMode()) {
		const testData = [
			{
				roleId: 0,
				roleName: "None",
			},
			{
				roleId: 1,
				roleName: "Guest",
			},
			{
				roleId: 4,
				roleName: "User",
			},
			{
				roleId: 8,
				roleName: "Admin",
			},
			{
				roleId: 10,
				roleName: "Owner",
			},
		];

		return simulateDelay(50, () => removeNone(testData));
	}

	return get(`discover/getOrgRoles`).then(removeNone);
};
